import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';

const ProtectedRoute = ({ allowedRoles }) => {
  const { user, loading } = useAuth();

  // ⏳ Wait for auth to rehydrate from localStorage before deciding
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff8f2',
        fontFamily: "'Segoe UI', sans-serif"
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '36px', marginBottom: '12px' }}>⏳</div>
          <div style={{ color: '#94a3b8', fontSize: '14px', fontWeight: 600 }}>Loading...</div>
        </div>
      </div>
    );
  }

  // 🔐 Not logged in — redirect to login
  if (!user || !user.token) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 Logged in but role not allowed
  if (
    allowedRoles &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user?.role)
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          padding: '24px',
          backgroundColor: '#fff8f2',
          overflowX: 'hidden'
        }}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default ProtectedRoute;